export function mergeSpecificKeys(defaults, overrides, keys) {
	return keys.reduce((acc, colorType) => {
		if (overrides[colorType]) {
			acc[colorType] = overrides[colorType];
		}

		return acc;
	}, defaults);
}
